import {useState} from "react";
import className from "classnames/bind";
import {FontAwesomeIcon} from "~/components";
import style from "../style/SeoCheck.module.scss";

const cn = className.bind(style);

// Lấy host hiển thị từ URL.
function hostOf(url) {
	try {
		return new URL(url).host;
	} catch {
		return url || '';
	}
}

// Breadcrumb kiểu Google: host › path › path
function breadcrumb(url) {
	try {
		const u = new URL(url);
		const parts = u.pathname.split('/').filter(Boolean);
		return [u.host, ...parts].join(' › ');
	} catch {
		return url || '';
	}
}

const TABS = [
	{key: 'google', label: 'Google', icon: 'fa-brands fa-google'},
	{key: 'facebook', label: 'Facebook', icon: 'fa-brands fa-facebook'},
	{key: 'twitter', label: 'X / Twitter', icon: 'fa-brands fa-x-twitter'},
];

/**
 * Xem trước hiển thị trang trên kết quả tìm kiếm Google + khi chia sẻ lên
 * Facebook / X(Twitter). Dùng dữ liệu meta.social do backend trích.
 */
function SerpPreview({social}) {

	const [tab, setTab] = useState('google');

	if (!social) return null;

	const title = social.title || '(Không có tiêu đề)';
	const desc = social.description || '(Không có mô tả)';
	const ogTitle = social.og_title || social.title || '(Không có tiêu đề)';
	const ogDesc = social.og_description || social.description || '';
	const ogImage = social.og_image;
	const twTitle = social.twitter_title || ogTitle;
	const twDesc = social.twitter_description || ogDesc;
	const twImage = social.twitter_image || ogImage;
	const host = hostOf(social.url);

	return (
		<div className={cn('serp')}>
			<div className={cn('serp-tabs')}>
				{TABS.map((t) => (
					<button
						key={t.key}
						type="button"
						className={cn('serp-tab', {active: tab === t.key})}
						onClick={() => setTab(t.key)}
					>
						<FontAwesomeIcon icon={t.icon} /> {t.label}
					</button>
				))}
			</div>

			<div className={cn('serp-body')}>
				{tab === 'google' && (
					<div className={cn('g-card')}>
						<div className={cn('g-head')}>
							<span className={cn('g-favicon')}><FontAwesomeIcon icon="fa-light fa-globe" /></span>
							<div>
								<div className={cn('g-site')}>{social.og_site_name || host}</div>
								<div className={cn('g-url')}>{breadcrumb(social.url)}</div>
							</div>
						</div>
						<div className={cn('g-title')}>{title}</div>
						<div className={cn('g-desc')}>{desc}</div>
					</div>
				)}

				{(tab === 'facebook' || tab === 'twitter') && (
					<div className={cn('s-card', tab)}>
						<div className={cn('s-image')}>
							{(tab === 'facebook' ? ogImage : twImage)
								? <img src={tab === 'facebook' ? ogImage : twImage} alt="preview" />
								: <div className={cn('s-image-empty')}><FontAwesomeIcon icon="fa-light fa-image" /> Không có ảnh{tab === 'facebook' ? ' og:image' : ' twitter:image'}</div>}
						</div>
						<div className={cn('s-meta')}>
							<div className={cn('s-domain')}>{host?.toUpperCase()}</div>
							<div className={cn('s-title')}>{tab === 'facebook' ? ogTitle : twTitle}</div>
							<div className={cn('s-desc')}>{tab === 'facebook' ? ogDesc : twDesc}</div>
						</div>
					</div>
				)}
			</div>
		</div>
	);
}

export default SerpPreview;
